import Vue from "vue";
import "vuetify/dist/vuetify.css";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VuetifyToast from "vuetify-toast-snackbar";
//import es from "vuetify/es5/locale/es";

Vue.use(VuetifyToast, {
  x: "right", // default
  y: "bottom", // default
  color: "info", // default
  icon: "info",
  timeout: 3000, // default
  dismissable: true, // default
  autoHeight: false, // default
  multiLine: false, // default
  vertical: false, // default
  shorts: {
    custom: {
      color: "purple"
    }
  },
  property: "$toast" // default
});
